import { Box, styled } from '@mui/material';

export const CarrierLogoStyled = styled('img')(({ theme }) => ({
  width: 'auto',
  maxWidth: theme.spacing(70),
  height: 'auto',
  objectFit: 'contain',
}));

export const CarrierLogoWrapperStyled = styled(Box)({
  height: '100%',
  maxWidth: '50%',
});
